// App brand comes from the address: /connect/... (or a connect.* host, or legacy ?brand=connect) => MorrConnect.
const BRANDS = {
  morrcart: { key: "morrcart", name: "MorrCart", title: "MorrCart — Embeddable Cart & Scheduling" },
  morrconnect: { key: "morrconnect", name: "MorrConnect", title: "MorrConnect — Profiles, Directory & Leads" },
};
export const CONNECT_PREFIX = "/connect";

export function hostBrand() {
  if (typeof window === "undefined") return BRANDS.morrcart;
  const { pathname, hostname, search } = window.location;
  const connect = pathname === CONNECT_PREFIX || pathname.startsWith(`${CONNECT_PREFIX}/`)
    || hostname.startsWith("connect.") || new URLSearchParams(search).get("brand") === "connect";
  return connect ? BRANDS.morrconnect : BRANDS.morrcart;
}

// App page path for a brand (current address by default): "/dashboard" -> "/connect/dashboard".
export function brandPath(path, appKey = hostBrand().key) {
  return appKey === "morrconnect" ? `${CONNECT_PREFIX}${path}` : path;
}

// Tenant verticals can carry their own brand (e.g. realestate/coaching/consulting => MorrConnect).
export function brandFor(vertical) {
  return vertical?.brand && BRANDS[vertical.brand] ? BRANDS[vertical.brand] : hostBrand();
}

export function applyBrandTitle(b = hostBrand()) {
  if (typeof document !== "undefined") document.title = b.title;
}
